let state = {
    SINOJ_Catalogos_002TiposCedula: {},
    SINOJ_Catalogos_003Jurisdicciones: {},
    SINOJ_Catalogos_009TiposPlantilla: {},
    SINOJ_Catalogos_019Fraccionamientos: {},
    SINOJ_Catalogos_021Zonas: {},
    SINOJ_Catalogos_007Empresas: {},
    SINOJ_Catalogos_020Notificadores: {},
    SINOJ_Catalogos_015TiposResultado: {},
    SINOJ_Catalogos_022TiposRazones: {},
    SINOJ_Catalogos_011TiposEstatus: {},
    SINOJ_ConsultaDeDireccion_Variables: {},
    SINOJ_CedulasSeleccionadas_ConsultaDeDireccion: [],
    SINOJ_CedulasDeSolicitud_ConsultaDeDireccion: [],
    SINOJ_CedulasSeleccionadas_SalidasDelDia: [],
    SINOJ_CedulasSeleccionadas_SalidasDeNotificador: [],
    SINOJ_Fraccionamientos_LocalStorage: []
}

let getters = {
    Get_SINOJ_Catalogos_002TiposCedula: state => {
        return state.SINOJ_Catalogos_002TiposCedula;
    },
    Get_SINOJ_Catalogos_003Jurisdicciones: state => {
        return state.SINOJ_Catalogos_003Jurisdicciones;
    },
    Get_SINOJ_Catalogos_009TiposPlantilla: state => {
        return state.SINOJ_Catalogos_009TiposPlantilla;
    },
    Get_SINOJ_Catalogos_019Fraccionamientos: state => {
        return state.SINOJ_Catalogos_019Fraccionamientos;
    },
    Get_SINOJ_Catalogos_021Zonas: state => {
        return state.SINOJ_Catalogos_021Zonas;
    },
    Get_SINOJ_Catalogos_007Empresas: state => {
        return state.SINOJ_Catalogos_007Empresas;
    },
    Get_SINOJ_Catalogos_020Notificadores: state => {
        return state.SINOJ_Catalogos_020Notificadores;
    },
    Get_SINOJ_Catalogos_015TiposResultado: state => {
        return state.SINOJ_Catalogos_015TiposResultado;
    },
    Get_SINOJ_Catalogos_022TiposRazones: state => {
        return state.SINOJ_Catalogos_022TiposRazones;
    },
    Get_SINOJ_Catalogos_011TiposEstatus: state => {
        return state.SINOJ_Catalogos_011TiposEstatus;
    },
    Get_SINOJ_ConsultaDeDireccion_Variables: state => {
        return state.SINOJ_ConsultaDeDireccion_Variables;
    },
    Get_SINOJ_CedulasSeleccionadas_ConsultaDeDireccion: state => {
        return state.SINOJ_CedulasSeleccionadas_ConsultaDeDireccion;
    },
    Get_SINOJ_CedulasDeSolicitud_ConsultaDeDireccion: state => {
        return state.SINOJ_CedulasDeSolicitud_ConsultaDeDireccion;
    },
    Get_SINOJ_CedulasSeleccionadas_SalidasDelDia: state => {
        return state.SINOJ_CedulasSeleccionadas_SalidasDelDia;
    },
    Get_SINOJ_CedulasSeleccionadas_SalidasDeNotificador: state => {
        return state.SINOJ_CedulasSeleccionadas_SalidasDeNotificador;
    },
    Get_SINOJ_Fraccionamientos_LocalStorage: state => {
        return state.SINOJ_Fraccionamientos_LocalStorage;
    },
}

let mutations = {
    M_SINOJ_Catalogos_establecer002TiposCedula(state, data) {
        state.SINOJ_Catalogos_002TiposCedula[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer003Jurisdicciones(state, data) {
        state.SINOJ_Catalogos_003Jurisdicciones[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer009TiposPlantilla(state, data) {
        state.SINOJ_Catalogos_009TiposPlantilla[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer019Fraccionamientos(state, data) {
        state.SINOJ_Catalogos_019Fraccionamientos[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer021Zonas(state, data) {
        state.SINOJ_Catalogos_021Zonas[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer007Empresas(state, data) {
        state.SINOJ_Catalogos_007Empresas[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer020Notificadores(state, data) {
        state.SINOJ_Catalogos_020Notificadores[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer015TiposResultado(state, data) {
        state.SINOJ_Catalogos_015TiposResultado[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer022TiposRazones(state, data) {
        state.SINOJ_Catalogos_022TiposRazones[data.llave] = data.valor;
    },
    M_SINOJ_Catalogos_establecer011TiposEstatus(state, data) {
        state.SINOJ_Catalogos_011TiposEstatus[data.llave] = data.valor;
    },
    M_SINOJ_establecerConsultaDeDireccion_Variables(state, data) {
        state.SINOJ_ConsultaDeDireccion_Variables = data;
    },
    M_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion(state, data) {
        state.SINOJ_CedulasSeleccionadas_ConsultaDeDireccion = data;
    },
    M_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion(state, data) {
        state.SINOJ_CedulasDeSolicitud_ConsultaDeDireccion = data;
    },
    M_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia(state, data) {
        state.SINOJ_CedulasSeleccionadas_SalidasDelDia = data;
    },
    M_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador(state, data) {
        state.SINOJ_CedulasSeleccionadas_SalidasDeNotificador = data;
    },
    M_SINOJ_Catalogos_establecerSINOJ_Fraccionamientos_LocalStorage(state, data) {
        state.SINOJ_Fraccionamientos_LocalStorage = data;
    },
}

let actions = {
    A_SINOJ_Catalogos_establecer002TiposCedula: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer002TiposCedula', data)
    },
    A_SINOJ_Catalogos_establecer003Jurisdicciones: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer003Jurisdicciones', data)
    },
    A_SINOJ_Catalogos_establecer009TiposPlantilla: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer009TiposPlantilla', data)
    },
    A_SINOJ_Catalogos_establecer019Fraccionamientos: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer019Fraccionamientos', data)
    },
    A_SINOJ_Catalogos_establecer021Zonas: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer021Zonas', data)
    },
    A_SINOJ_Catalogos_establecer007Empresas: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer007Empresas', data)
    },
    A_SINOJ_Catalogos_establecer020Notificadores: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer020Notificadores', data)
    },
    A_SINOJ_Catalogos_establecer015TiposResultado: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer015TiposResultado', data)
    },
    A_SINOJ_Catalogos_establecer015TiposRazones: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer022TiposRazones', data)
    },
    A_SINOJ_Catalogos_establecer011TiposEstatus: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecer011TiposEstatus', data)
    },
    A_SINOJ_establecerConsultaDeDireccion_Variables: ({ commit }, data) => {
        commit('M_SINOJ_establecerConsultaDeDireccion_Variables', data)
    },
    A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion: ({ commit }, data) => {
        commit('M_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion', data)
    },
    A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion: ({ commit }, data) => {
        commit('M_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion', data)
    },
    A_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia: ({ commit }, data) => {
        commit('M_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia', data)
    },
    A_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador: ({ commit }, data) => {
        commit('M_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador', data)
    },
    A_SINOJ_establecerSINOJ_Fraccionamientos_LocalStorage: ({ commit }, data) => {
        commit('M_SINOJ_Catalogos_establecerSINOJ_Fraccionamientos_LocalStorage', data)
    },
}

const SINOJ = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}
export default SINOJ;



// WEBPACK FOOTER //
// ./src/store/SINOJ.js